import { Autocomplete, Box, IconButton, TextField, Tooltip } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useEffect, useRef } from 'react';
import { supabase } from '../config/supabase';
import { addressTimezone, defaultEventTimezone, validTimezone } from '../../shared/eventTimezones';

const zones = ['UTC', ...Intl.supportedValuesOf('timeZone')];
export function EventTimezoneField({ value, manual, onChange, facilityId, location }: { value: string; manual: boolean; onChange: (value: string, manual: boolean) => void; facilityId?: string; location?: string }) {
  const change = useRef(onChange);
  change.current = onChange;
  useEffect(() => {
    if (manual || facilityId === undefined) return;
    let cancelled = false;
    void (async () => {
      const facility = facilityId ? await supabase.from('facilities').select('zip_code,state').eq('id', facilityId).maybeSingle() : null;
      if (!cancelled) change.current((facilityId ? addressTimezone(facility?.data) : addressTimezone(location)) || defaultEventTimezone, false);
    })();
    return () => { cancelled = true; };
  }, [facilityId, location, manual]);
  return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Autocomplete freeSolo fullWidth options={zones} value={value} onChange={(_, next) => onChange(next || '', true)} onInputChange={(_, next, reason) => { if (reason === 'input' || reason === 'clear') onChange(next, true); }} renderInput={(params) => <TextField {...params} label={`Timezone (${manual ? 'Manual' : 'Address'})`} error={!validTimezone(value)} required />} />
    <Tooltip title="Use address timezone"><IconButton aria-label="Use address timezone" onClick={() => onChange(value, false)}><RestartAltIcon /></IconButton></Tooltip>
  </Box>;
}
